<template>
  <roe-error-message :field="design[attrName]">
    <v-select
      v-model="design.$model[attrName]"
      :name="attrName"
      :options="[
        { code: 0, label: 'Immediate Vesting' },
        { code: 1, label: 'Cliff Vesting' },
        { code: 2, label: 'Graded Vesting' }
      ]"
      :reduce="label => label.code"
      required
      @input="resetAttributes(design, attrName)"
    >
    </v-select>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
import ResetDesignAttributesMixin from "@/components/_shared/inputs/design/_mixins/ResetDesignAttributesMixin";
export default {
  name: "RoeVestingSelect",
  components: { RoeErrorMessage },
  mixins: [ResetDesignAttributesMixin],
  props: {
    design: Object,
    type: {
      type: String,
      default() {
        return "other";
      }
    }
  },
  data() {
    return {
      attrName:
        this.type === "match"
          ? "percent_match_vesting_immediate"
          : "employer_other_vesting_immediate"
    };
  }
};
</script>
